module.exports = __webpack_public_path__ + "img/kepit_logo_full.dac31c3d.png";